import Identified from "@mapmycustomers/shared/types/base/Identified";

const defaultIdGetter = <T>({ id }: Identified<T>): string => `${id}`;

export default defaultIdGetter;
